import { render, staticRenderFns } from "./profileAdmin.vue?vue&type=template&id=72f4991e&scoped=true&"
import script from "./profileAdmin.vue?vue&type=script&lang=js&"
export * from "./profileAdmin.vue?vue&type=script&lang=js&"
import style0 from "./profileAdmin.vue?vue&type=style&index=0&id=72f4991e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f4991e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCard,VCardText,VDialog,VDivider,VProgressLinear})
